import React from 'react';
import './OrderDetailsShared.css';

/** Grey order-details grid. Callers pass ready-to-show strings. */
function OrderStatusGrid({ orderId, status, eta, distance, truck, trailer, className = '', style }) {
  return (
    <div className={`status-section ${className}`} style={style}>
      <div className="detail-item detail-item--order">
        <span className="detail-label">Order Number</span>
        <span className="detail-value">{orderId}</span>
      </div>
      <div className="detail-item detail-item--status">
        <span className="detail-label">Status</span>
        <span className={`detail-value ${status === 'Cancelled' ? 'cancelled-status' : ''}`}>{status}</span>
      </div>
      <div className="detail-item detail-item--eta">
        <span className="detail-label">ETA</span>
        <span className="detail-value">{eta}</span>
      </div>
      <div className="detail-item detail-item--distance">
        <span className="detail-label">Distance remaining</span>
        <span className="detail-value">{distance}</span>
      </div>
      <div className="detail-item detail-item--truck">
        <span className="detail-label">Truck #</span>
        <span className="detail-value">{truck}</span>
      </div>
      <div className="detail-item detail-item--trailer">
        <span className="detail-label">Trailer #</span>
        <span className="detail-value">{trailer}</span>
      </div>
    </div>
  );
}

export default OrderStatusGrid;
